import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import {
  getToken,
  setToken,
  setRefreshToken,
  getRefreshToken,
  getInfo
} from "./auth";
let isCallMissRequest = true;
let isRenew = false;
let isLogin = true;
// Create axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60 * 10 * 1000, // Request timeout
  headers: {
    // "X-Access-Token": getToken(),
    "Access-Control-Allow-Origin": "*" // Allow CORS
  }
});

// request拦截器
service.interceptors.request.use(
  config => {
    const { user_id } = getInfo();
    config.params = { ...config.params, uid: user_id };
    if (getToken())
      config.headers = { ...config.headers, "X-Access-Token": getToken() };
    return config;
  },
  error => {
    // Do something with request error
    console.log(error, "error"); // for debug
    Promise.reject(error);
    // window.location.reload();
  }
);

// response pre-processing
service.interceptors.response.use(
  async response => {
    const res = response.data;
    if (res.error_code !== 0) {
      console.log(response.data);
      if (res.error_code === 1016) {
        if (!isLogin) return;
        isLogin = false;
        reLoginBlockDialog(res.error_msg, "warning");
        return;
      }
      if (res.error_code === 1004 || res.error_code === 1011) {
        // Token Expired or No access Token or Token Invalid
        if (isRenew) {
          await new Promise(resolve => setTimeout(resolve, 1100));
          if (!isCallMissRequest) return;
          const originalRequest = response.config;
          originalRequest._retry = true;
          // missRequest.push(originalRequest)
          console.log("set missRequest___________", originalRequest);
          const resMiss = await service(originalRequest);
          if (resMiss.error_code === 0) {
            return resMiss;
          }
          return;
        }
        if (!isRenew) isRenew = true;
        const refreshToken = getRefreshToken();
        const data = await service.post("/account/renew", {
          refresh_token: refreshToken
        });
        console.log("data refreshToken________________________", data);
        if (data.error_code !== 0) {
          isCallMissRequest = false;
          // isRenew = false;
          store.dispatch("user/resetToken");
          reLoginBlockDialog(data.error_msg);
          return;
        }
        if (data.error_code === 0) {
          const { access_token, refresh_token } = data.data;
          const originalRequest = response.config;
          originalRequest._retry = true;
          axios.defaults.headers.common["X-Access-Token"] = access_token;
          // set refresh token
          setRefreshToken(refresh_token);
          setToken(access_token);
          isRenew = false;
          return service(originalRequest);
        }
      }
    }
    return response.data;
  },
  error => {
    console.log("err" + error);
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
);
const reLoginBlockDialog = (error_msg, type = "error") => {
  MessageBox.confirm(error_msg, "Notification", {
    showCancelButton: false,
    confirmButtonText: "Login",
    type
  })
    .then(() =>
      store
        .dispatch("user/resetToken")
        .then(() => store.dispatch("showLoginDialog"))
    )
    .finally(() => {
      isLogin = true;
      store.dispatch("user/resetToken");
    });
  // store
  //   .dispatch("user/resetToken")
  //   .then(() => store.dispatch("showLoginDialog"));
};
const Login = error_msg => {
  MessageBox.confirm(error_msg, "Notification", {
    showCancelButton: false,
    confirmButtonText: "Login",
    type: "error"
  }).then(() => {
    store
      .dispatch("user/resetToken")
      .then(() => store.dispatch("showLoginDialog"));
  });
};
export default service;
